/**
 * useEscapeKey — run a callback when Escape is pressed.
 * Pass `enabled` to only listen while an overlay/dropdown is open.
 */
import { useEffect } from 'react';

export function useEscapeKey(onEscape: () => void, enabled = true) {
  useEffect(() => {
    if (!enabled) return;
    const handle = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onEscape();
    };
    document.addEventListener('keydown', handle);
    return () => document.removeEventListener('keydown', handle);
  }, [onEscape, enabled]);
}
